module.exports = __webpack_public_path__ + "static/media/small-info-icon.b8020f7a.svg";